import { Link } from 'react-router-dom';
import macName from '../lib/macName';
import { LIVE_STATUSES } from './RunCharts';

// everything going on right now, wherever it runs: built from /api/me/workspace.
// training only (macs and cloud) for the home page; the workspace adds chat and backups.
export function nowItems(data, { trainingOnly = false } = {}) {
  // the home page lists training only, so the verb goes and the name gets the room
  const verb = trainingOnly ? '' : 'training ';
  const bpb = (x) => (typeof x === 'number' ? `${x.toFixed(3)} bpb` : '');
  const fromMacs = (data?.apps || []).flatMap((a) => {
    const t = a.state?.training || {}; const c = a.state?.chat || {}; const b = a.state?.backup || {};
    return [
      t.running && { key: `${a.token_id}-t`, to: `/remote/${a.token_id}`, what: `${verb}${t.name || ''}`, where: macName(a.name),
        detail: bpb(t.recent_bpb) },
      !trainingOnly && c.loaded && { key: `${a.token_id}-c`, to: `/remote/${a.token_id}`, what: `chat · ${c.name || ''}`, where: macName(a.name),
        detail: c.busy ? 'replying' : 'loaded' },
      !trainingOnly && b.running && { key: `${a.token_id}-b`, to: `/remote/${a.token_id}`, what: `backing up ${b.name || ''}`, where: macName(a.name),
        detail: typeof b.progress === 'number' ? `${Math.round(b.progress * 100)}%` : '' },
    ].filter(Boolean);
  });
  const fromCloud = (data?.runs || []).filter((r) => LIVE_STATUSES.includes(r.status)).map((r) => ({
    key: r.run_id, to: `/runs/${r.run_id}`, what: `${verb}${r.name}`, where: `cloud · ${r.gpu_name || ''}`,
    detail: bpb(r.latest?.bpb) || r.status,
  }));
  return [...fromMacs, ...fromCloud];
}

export default function NowRows({ items }) {
  return (
    <div className="divide-y divide-[#1a201b] border-y border-[#1a201b]">
      {items.map((n) => (
        <Link key={n.key} to={n.to} className="py-2.5 flex items-baseline gap-3 group font-mono">
          <span className="w-2 h-2 rounded-full shrink-0 self-center" style={{ background: 'rgb(77, 255, 133)' }} />
          <span className="min-w-0 text-sm text-white lowercase truncate group-hover:underline underline-offset-4 decoration-[#444444]">{n.what}</span>
          <span className="text-[10px] lowercase px-2 py-0.5 rounded border border-[#383f38] text-[#bbbbbb] min-w-0 truncate shrink-[3]">{n.where}</span>
          <span className="ml-auto text-xs text-[#888888] shrink-0">{n.detail}</span>
        </Link>
      ))}
    </div>
  );
}
